import React from 'react';
import { Tooltip } from '@material-ui/core';

// Marks a lead that is linked to a contact in the CRM, with the id on hover.
//
// A marker rather than a column: the id is only occasionally needed (to look the
// person up in Albi) and a whole column of long numeric strings would crowd out
// the fields staff read on every row. Staff-facing views only — the lead
// endpoints that carry crm_contact_id are all behind readOnlyMiddleware.
const CrmBadge = ({ contactId }) => {
  if (!contactId) return null;

  return (
    <Tooltip title={`CRM contact ID: ${contactId}`}>
      <span
        style={{
          display: 'inline-block',
          marginLeft: 6,
          padding: '0 5px',
          borderRadius: 3,
          border: '1px solid #4E564E',
          color: '#4E564E',
          fontSize: '0.65rem',
          fontWeight: 700,
          letterSpacing: '0.04em',
          verticalAlign: 'middle',
          cursor: 'default',
        }}
      >
        CRM
      </span>
    </Tooltip>
  );
};

export default CrmBadge;
